import { useState } from 'react';
import { v4 as uuid } from 'uuid';
import {
  ButtonSecondary,
  ButtonSize,
  IconDown,
  IconExpand,
  IconUp,
} from '@ui/src';
import { ExpectedOriginFundsContentTypes } from './types';
import ExpectedOriginFund from './expected-origin-fund';
import { ExpectedFundsOriginsFormValues } from '../../../../../hoc/new-application/types';

import cn from './styles.module.css';

const ExpectedOriginFundsContent = ({
  type,
  status,
  currencies,
  deleteExpectedFundsOriginsInProgress,
  onDeleteExpectedFundsOrigins,
  expectedFundsOriginsValues,
  expectedFundsOriginsValuesList,
  setExpectedFundsOriginsValues,
  countries,
  selectedExpectedFundsOriginsId,
}: ExpectedOriginFundsContentTypes) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className={cn.expectedFundsOriginsWrapper}>
      <div>
        <button
          type="button"
          className={cn.expectedFundsOriginsTitle}
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? <IconUp /> : <IconDown />}
          {`${type.charAt(0)}${type.slice(1).toLowerCase()} funds (${type === 'INCOMING' ? 'credited' : 'debited'} to the account)`}
        </button>
      </div>
      {expanded && (
        <>
          {expectedFundsOriginsValues &&
            expectedFundsOriginsValues?.length > 0 &&
            expectedFundsOriginsValues?.map((item, index) => (
              <ExpectedOriginFund
                key={item.id}
                status={status}
                currencies={currencies}
                deleteExpectedFundsOriginsInProgress={
                  deleteExpectedFundsOriginsInProgress
                }
                onDeleteExpectedFundsOrigins={onDeleteExpectedFundsOrigins}
                selectedExpectedFundsOriginsId={selectedExpectedFundsOriginsId}
                expectedFundsOrigin={item}
                setExpectedFundsOriginsValues={setExpectedFundsOriginsValues}
                expectedFundsOrigins={expectedFundsOriginsValuesList}
                index={index}
                countries={countries}
              />
            ))}
          <ButtonSecondary
            size={ButtonSize.SMALL}
            className={`${cn.addCounterparties} button-white`}
            icon={<IconExpand />}
            text="Add Counterparties"
            onClick={() => {
              let nextExpectedfundsOrigins: ExpectedFundsOriginsFormValues[] =
                [];

              if (expectedFundsOriginsValuesList) {
                nextExpectedfundsOrigins = (
                  [] as ExpectedFundsOriginsFormValues[]
                ).concat(expectedFundsOriginsValuesList);
              }

              nextExpectedfundsOrigins.push({
                id: `expected-funds-origins-${uuid()}`,
                currencyId: '',
                mainCounterpartiesAndWebsites: '',
                countryOfIncorporationId: '',
                counterpartyBankCountryIds: [],
                activityCountryIds: [],
                mainActivities: '',
                transactionReason: '',
                transactionType: type,
              });

              setExpectedFundsOriginsValues(nextExpectedfundsOrigins);
            }}
          />
        </>
      )}
    </div>
  );
};

export default ExpectedOriginFundsContent;
